import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * AuthInterceptor - Now handled by MsalInterceptor
 * This interceptor is kept for backward compatibility but token management
 * is now handled by @azure/msal-angular MsalInterceptor
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // MsalInterceptor handles token attachment now
    // This interceptor can be used for additional auth-related headers if needed
    return next.handle(request);
  }
}
